import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';


const StyledSlider = styled(motion.div)`
    width: 100vw;
    height: 100vh;
    min-height: 800px;
    background-color: #fff;
    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.12);
    border-radius: 20px 20px 0 0;
    z-index: 1600;
    position: absolute;
    top: calc(100vh - 330px);
    overflow: hidden;
    padding: 30px 12px 0;
    box-sizing: border-box;

    &::before {
        content: "";
        width: 24px;
        height: 4px;
        background-color: #E0E0E0;
        position: absolute;
        left: 50%;
        top: 12px;
        margin-left: -12px;

    }

    @media screen and (orientation: landscape)  {
        height: auto;
    }
`


let topLimit = window.innerHeight / 1.75;
let bottomLimit = window.innerHeight / 3.9;

if (window.innerHeight < 630) {
    topLimit = window.innerHeight / 1.75;
    bottomLimit = window.innerHeight / 3.9;

    if (window.innerHeight < 600) {
        topLimit = window.innerHeight / 1.2;
        bottomLimit = window.innerHeight / 4.5;
    }

    if (window.innerHeight < 300) {
        topLimit = window.innerHeight * 5;
        bottomLimit = window.innerHeight / 10;
    }
}

if (window.innerHeight < window.innerWidth) {
    topLimit = 100;
    bottomLimit = 300;
}

const constraints = { top: -topLimit, bottom: bottomLimit};


const SlidingPane = props => {


    return (

        <StyledSlider
            drag="y"
            dragConstraints={constraints}
            dragTransition={{ bounceStiffness: 600, bounceDamping: 20 }}

        >
            {props.children}

        </StyledSlider>

    )

};

export default SlidingPane;
